<template>
  <div>
    <Divider dashed>电费价格</Divider>
    <p class="text-right m-b-5">
      <a @click="onAddConsumption"><Icon type="md-add" />新增电费价格</a>
    </p>
    <Table stripe size="small" :data="tableData" :columns="tableColumns"></Table>

    <Modal v-model="electrictyPriceModal" :mask-closable="false" footer-hide width="400">
      <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>{{ formValidate.id? '编辑':'新增' }}电费价格</span>
      </p>

      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="月份" prop="chargeMoth">
          <DatePicker type="month" placeholder="设置电费时间" v-model="formValidate.chargeMoth"></DatePicker>
        </FormItem>
        <FormItem label="价格" prop="unitPrice">
            <Input v-model="formValidate.unitPrice" type="number" style="width: 190px;" placeholder="请输入电费单价"></Input>
        </FormItem>
        <FormItem label="单位" prop="unit">
            元/KWh
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            <Button @click="handleReset('formValidate')" style="margin-left: 8px; color: #000">重置</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { listMeterPrice, saveUnitPrice, updateUnitPrice } from '@/api/invest/electricMeterPrice'

export default {
  data () {
    return {
      tableData: [],
      tableColumns: [
        { title: '时间', key: 'month' },
        { title: '电费单价', key: 'unitPrice' },
        {
          title: '操作',
          align: 'center',
          width: 50,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.hanldeEditItem(params.row)
                  }
                }
              }, '编辑')
            ])
          }
        }
      ],

      electrictyPriceModal: false,
      formValidate: {
        id: null,
        chargeMoth: '',
        unitPrice: null
      },
      ruleValidate: {
        unitPrice: [
          { required: true, message: '电价不能为空', trigger: 'blur' }
        ],
        chargeMoth: [
          { required: true, type: 'date', message: '电价月份不能为空', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      listMeterPrice().then(res => {
        this.tableData = res.sort((a, b) => b.month.localeCompare(a.month))
      })
    },
    onAddConsumption () {
      this.electrictyPriceModal = true
      this.formValidate.id = null
      this.handleReset('formValidate')
    },
    hanldeEditItem (params) {
      this.electrictyPriceModal = true
      this.formValidate.id = params.id
      this.formValidate.chargeMoth = new Date(params.chargeMoth)
      this.formValidate.unitPrice = params.unitPrice
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 格式化日期
          const chargeMonth = new Date(this.formValidate.chargeMoth)
          this.formValidate.chargeMoth = chargeMonth.getFullYear() + '-' + (chargeMonth.getMonth() + 1 + '').padStart(2, '0') + '-01'

          if (this.formValidate.id) {
            updateUnitPrice(this.formValidate).then(res => {
              if (res) {
                this.initPageData()
                this.electrictyPriceModal = false
                this.$Notice.success({ desc: '编辑电表单价成功！' })
              }
            })
          } else {
            saveUnitPrice(this.formValidate).then(res => {
              if (res) {
                this.initPageData()
                this.electrictyPriceModal = false
                this.$Notice.success({ desc: '新增电表单价成功！' })
              }
            })
          }
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
